module.exports = __webpack_public_path__ + "img/cb_maintenance_img.7605b74b.png";